import './assets/main.css'

import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

import { createVuetify } from 'vuetify'
import { md3 } from 'vuetify/blueprints'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { createApp, h, provide } from 'vue'
import { createPinia } from 'pinia'
import { createI18n, type I18nOptions } from 'vue-i18n'

import itMessages from './locales/it.json'
import itDatetimeFormats from './locales/datetime-it.json'

import App from './App.vue'
import router from './router'
import { DefaultApolloClient } from '@vue/apollo-composable'
import client from './graphql/apollo'
import { getRaceSyncService } from '@/services/race_sync_service'
import { useAuthStore } from '@/stores/auth'
import * as Sentry from '@sentry/vue'

const i18n = createI18n({
  legacy: false,
  locale: 'it',
  messages: {
    it: itMessages,
  },
  datetimeFormats: {
    it: itDatetimeFormats,
  } as I18nOptions['datetimeFormats'],
})

const vuetify = createVuetify({
  components,
  directives,
  blueprint: md3,
})

const app = createApp({
  setup() {
    provide(DefaultApolloClient, client)
  },
  render: () => h(App),
})

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
});

app.use(createPinia())
app.use(router)
app.use(vuetify)
app.use(i18n)

const authStore = useAuthStore()
getRaceSyncService().initialize(authStore)

app.mount('#app')
